import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { useEffect, useRef } from 'react'
import { ModelNode } from '../types'

type Props = {
  item: ModelNode
  onItemSelected: (itemId: ModelNode, multiSelection: boolean) => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      padding: '.8em',
      paddingLeft: (props: { level: number }) => `${0.8 * props.level + 1}em`,
      backgroundColor: theme.palette.action.disabled,
    },
    listItemActive: {
      backgroundColor: `${theme.palette.info.light} !important`,
      color: theme.palette.getContrastText(theme.palette.info.light),
    },
    has3dModel: {
      backgroundColor: 'unset',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        cursor: 'pointer',
      },
    },
  })
)

export const ModelExplorerItem = (props: Props) => {
  const cn = useStyles({ level: props.item.level })

  const itemRef = useRef<HTMLLIElement>()

  useEffect(() => {
    if (props.item.selected) {
      itemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }, [props.item.selected])

  return (
    <li
      onClick={(ev) => {
        props.onItemSelected(props.item, ev.ctrlKey || ev.metaKey)
      }}
      className={[
        cn.listItem,
        props.item.view3dObject ? cn.has3dModel : '',
        props.item.selected ? cn.listItemActive : '',
      ].join(' ')}
      ref={itemRef}
    >
      {props.item.text}
    </li>
  )
}
